import { Link } from "react-router-dom";
import { Users, Sun, Target, Snowflake, ArrowRight } from "lucide-react";
import { PROGRAMS } from "@/lib/constants";
import { Reveal } from "@/components/Reveal";
import { BlazerWay } from "@/components/BlazerWay";

const ICONS = { users: Users, sun: Sun, target: Target, snowflake: Snowflake };

export function Programs() {
  return (
    <section id="programs" className="relative py-20 sm:py-28 lg:py-32 bg-ink-800">
      <div className="container-x">
        <Reveal className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-blaze-orange">What We Offer</span>
          <h2 className="mt-3 font-display font-black uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl text-white leading-none">
            Our <span className="text-gradient-blaze">Programs</span>
          </h2>
          <p className="mt-5 text-lg text-white/70 leading-relaxed">
            From competitive AAU teams to skill-building clinics and one-on-one training — a pathway for every player to
            grow the <BlazerWay className="font-bold" />.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-6 sm:grid-cols-2">
          {PROGRAMS.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <Reveal key={p.key} delay={i * 0.08}>
                <Link
                  to={p.to}
                  data-testid={`program-card-${p.key}`}
                  className="hover-lift group relative block h-full overflow-hidden rounded-2xl border border-white/10 bg-ink-700 hover:border-blaze-orange/40"
                >
                  <div className="relative h-44 overflow-hidden">
                    <img src={p.image} alt={p.title} className="h-full w-full object-cover object-center opacity-70 transition-transform duration-700 group-hover:scale-110" />
                    <div className="absolute inset-0 bg-gradient-to-t from-ink-700 via-ink-700/40 to-transparent" />
                    <div className="absolute top-4 left-4 grid h-11 w-11 place-items-center rounded-lg bg-blaze-blue text-white shadow-lg">
                      <Icon size={22} />
                    </div>
                    {p.badge && (
                      <span className="absolute top-4 right-4 rounded-full bg-blaze-orange px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-ink-900">
                        {p.badge}
                      </span>
                    )}
                  </div>
                  <div className="p-6 sm:p-7">
                    <p className="text-xs font-bold uppercase tracking-[0.2em] text-blaze-orange">{p.season}</p>
                    <h3 className="mt-2 font-heading text-2xl sm:text-3xl tracking-wide text-white uppercase leading-none">
                      {p.title}
                    </h3>
                    <p className="mt-3 text-sm text-white/65 leading-relaxed">{p.desc}</p>
                    <span className="mt-5 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-white group-hover:text-blaze-orange transition-colors">
                      {p.cta} <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
